import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ReportData, ReportGroupBy, ReportOrderBy, ReportSubtype } from '../../models/Report';

export interface filterState {
  value: ReportHubFilter;
}

interface ReportHubFilter {
  selectedReportSubtype: ReportSubtype | null;
  totalRecords: number;
  values: ReportData;
  key: number | null;
}
const reportHubInitialState: filterState = {
  value: {
    selectedReportSubtype: null,
    totalRecords: 0,
    values: {
      roadmap: '',
      classes: [],
      sites: '',
      standards: '',
      groupedBy: ReportGroupBy.UNIT,
      orderBy: ReportOrderBy.ROWS,
    },
    key: null,
  },
};

export const filterReportHubSlice = createSlice({
  name: 'reportHubFilter',
  initialState: reportHubInitialState,
  reducers: {
    setReportHubFilter: (state, action: PayloadAction<ReportHubFilter>) => {
      state.value = action?.payload;
    },
  },
});

export const selectedReportHubFilter = (state: RootState) => state?.reportHubFilter?.value;

export const { setReportHubFilter } = filterReportHubSlice.actions;

export default filterReportHubSlice.reducer;
